import React, {Component} from 'react';

class VariantSelector extends Component {
  render() {
    return (
      <button
        onClick={this.props.handleOptionChange}
        name={this.props.variant.title}
        value={this.props.variant.id}
        key={`${this.props.variant.title}-${this.props.variant.id}`}
        disabled={!this.props.variant.available}
      >
        {`${this.props.variant.title}`}
      </button>
    );
  }
}

export default VariantSelector;
